import axios from 'axios'
// axios.defaults.baseURL = 'http://39.104.71.153:8066';

export default {
    state:{
        shop:{
            name:'芳子美容罗湖店'
        }
    },
    mutations:{

    },
    getters:{

    },
    actions:{

    }
}



// WEBPACK FOOTER //
// ./src/components/friend/friend.js